import { Star } from "lucide-react";
import { EMAIL, GOOGLE_REVIEW_URL } from "@/data/site";
import { Reveal } from "@/components/Reveal";

const reviewHref =
  GOOGLE_REVIEW_URL || `mailto:${EMAIL}?subject=${encodeURIComponent("My review of Freedom Mobile Auto Detailing")}`;
const external = Boolean(GOOGLE_REVIEW_URL);

const Reviews = () => (
  <section className="border-y border-white/10 bg-surface" data-testid="reviews-section">
    <div className="mx-auto max-w-3xl px-5 py-24 text-center sm:px-8 sm:py-28">
      <Reveal>
        <div className="mx-auto flex w-max items-center gap-1.5" aria-hidden="true">
          {[...Array(5)].map((_, i) => (
            <Star key={i} size={18} className="text-slate-600" strokeWidth={1.6} />
          ))}
        </div>
        <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight text-white sm:text-5xl">
          Customer Reviews
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-6 text-base leading-relaxed text-slate-300 sm:text-lg">
          Recently used Freedom Mobile Auto Detailing?
          <br />
          We'd love to hear about your experience.
        </p>
        <p className="mt-3 text-sm text-slate-500">
          Real Google reviews will be featured here as they come in — we don't post made-up testimonials.
        </p>
        <a
          href={reviewHref}
          {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
          className="btn-outline mt-8"
          data-testid="leave-review-button"
        >
          Leave a Review
        </a>
      </Reveal>
    </div>
  </section>
);

export default Reviews;
